module.exports = "<i *ngIf=\"isEditable\" class=\"edit-icon fas fas-pencil\"></i>\n<i *ngIf=\"!isEditable\" class=\"edit-icon fas fas-search\"></i>\n"